import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useMemo } from "react";
import { pageStore, useGlobalStore, XDataGrid } from "../../common";
import { dateEquators, StringEquators } from "../../store/constants/pages";
import { createStringDataField, createIconDataField, createDateField, createSecondLevelField } from "../../util/format";
import { Edit as EditIcon } from '@mui/icons-material';
import { DeleteConfirmation } from "../../common/DeleteConfirmation";

export const ProvidersPageGrid = ({ paginationFilters, selectedProviderIdsPtr, loading, data, showSearchFilters,
    onLoad, refresh, defaultCustomFilter, handleEdit, handleDelete
}) => {

    const fields = useColumnDefinitions();

    const actions = params => [
        <GridActionsCellItem
            icon={<Tooltip title="Edit"><EditIcon /></Tooltip>}
            label="Edit"
            onClick={() => handleEdit( params.row )}
            sx={{ color: "primary.main" }}
        />,

        <GridActionsCellItem
            icon={<DeleteConfirmation handleDelete={() => handleDelete( params.row )} />}
            label="Delete"
        />
    ];

    return <>
        <XDataGrid
            fields={fields}
            actions={actions}
            data={data}
            loading={loading}
            selectedIdsPtr={selectedProviderIdsPtr}
            showSearchFilters={showSearchFilters}
            paginationFilters={ paginationFilters }
            onLoad={onLoad}
            refresh={refresh}
            defaultCustomFilter={defaultCustomFilter}
            name="providers-landing"
            defaultSort={DEFAULT_SORT}
            defaultHiddenFields={DEFAULT_HIDDEN_FIELDS}
            criteriasSaveEnabled={false}
        />
    </>
}

const useColumnDefinitions = () => {
    const npiRoles = useGlobalStore( x => x.npiRoles.data ?? [] );
    const statuses = [{ name: 'Active' }, { name: 'Inactive' }];
    return useMemo(() => {
        const fields = [
            createStringDataField('id', 'Id', { hideFromFilter: true, hideFromGrid: true }),
            createStringDataField('npi', 'NPI', { sortable: true, equators: StringEquators }),
            createStringDataField('providerName', 'Provider Name', { sortable: true, equators: StringEquators }),
            createStringDataField('npirole.name', 'Role', { equators: StringEquators, isDropdown: true, dropdownValues:npiRoles?.map((item)=>item?.name) ?? [], secondLevel: 'name' }),
            createStringDataField('providerType', 'Provider Type', { sortable: true, equators: StringEquators }),
            createStringDataField('degree', 'Degree', { sortable: true, equators: StringEquators }),
            createStringDataField('taxonomyCode', 'Taxonomy Code', { sortable: true, equators: StringEquators }),
            createStringDataField('specialty', 'Specialty', { sortable: true, equators: StringEquators }),
            createStringDataField('tin', 'TIN', { sortable: true, equators: StringEquators }),
            createStringDataField('primaryFacility', 'Primary Facility', { sortable: true, equators: StringEquators }),
            createStringDataField('state', 'State', { sortable: true, equators: StringEquators }),
            createStringDataField('status', 'Status', { sortable: true, equators: StringEquators, isDropdown: true, dropdownValues:statuses?.map((item)=>item?.name) ?? [] }),
            createIconDataField('isActive', 'Active', { hideFromFilter: true, icon: 'fas fa-check-circle', sortable: true,
                renderCell: (params) => 
                    params.value ? (
                        <i className="fas fa-check-circle text-success" style={{ fontSize: '1.3rem' }} />
                    ) : (
                        <i className="fas fa-check-circle text-secondary" style={{ fontSize: '1.3rem' }} />
                    ),
             }),
            createDateField('createdAt', 'Created At', { sortable: true, equators: dateEquators }),
            createStringDataField('createdBy', 'Created By', { sortable: true, equators: StringEquators }),
            createDateField('updatedAt', 'Updated At', { sortable: true, equators: dateEquators }),
            createStringDataField('updatedBy', 'Updated By', { sortable: true, equators: StringEquators }),
        ];
        return fields;
    }, []);
}

const DEFAULT_SORT = [{ id: 'npi', direction: 'desc' }];
const DEFAULT_HIDDEN_FIELDS = ["createdBy", "createdAt"];
const { usePageStore } = pageStore('providers-landing');